import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Modal, Card } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faEye, faPen, faPlus, faTrash, faFilter, faSync 
} from '@fortawesome/free-solid-svg-icons';
import useFetch from '../../../hooks/useFetch';
import PaginatedItems from '../../../components/administracao/Pagination';

function GerenciarExemplos() {
    // https://create-react-app.dev/docs/adding-custom-environment-variables/
    const { get, del } = useFetch();
    const { params } = useParams(); // pega o que vem depois da barra na url

    const defaultState = {
        exemplos: [],
        count: 0,
        page: 1,
        filtroAtivo: false,
        filtros: {
            nome: "",
            descricao: ""
        },
        mostrarModal: false,
        registroAExcluir: { nome: "" },
        loading: true
    };

    // Roda quando a página é carregada https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    const [state, setState] = useState(() => {
        return defaultState;
    });

    useEffect(() => {
        const initialize = async () => {
            let [exemplos, count] = await buscarExemplos({});
            setState({ ...state, exemplos: exemplos, count: count, loading: false });
        }
        initialize();
    }, [params]);

    // função de paginação
    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let filtroPaginacao = { page: pageNumber };
        if (state.filtroAtivo) {
            filtroPaginacao = { ...filtroPaginacao, page: pageNumber };
        }
        let [exemplos, count] = await buscarExemplos(filtroPaginacao);
        setState({ ...state, page: pageNumber, exemplos: exemplos, count: count, loading: false });
    }

    // Busca os dados do banco
    async function buscarExemplos(filtros) {
        if (!state.loading) setState({ ...state, loading: true });

        // filtros = { nome: "nome", descricao: "descricao" }
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        // no fim fica: nome=nome&descricao=descricao&
        try {
            let response = await get(`/exemplo${query}`);
            console.log("response ", response);
            if (response.ok) {
                console.log(response.result);
                let dados = response.result;
                return [dados.data, dados.count];
            } else if (response.error) {
                console.log(response);
                console.error('Erro no buscarExemplos()', response.error);
            }
        } catch (error) {
            console.error('Erro no buscarExemplos():', error);
        }
    }

    // Função acionada quando o usuário clica em buscar
    async function filtrarExemplos() {
        // adiciona os dados no objeto filtros se eles não forem vazios
        // Busca os dados do banco com os filtros
        let [exemplos, count] = await buscarExemplos(state.filtros);
        // Atualiza o estado com os dados buscados
        setState({ ...state, filtroAtivo: true, count: count, exemplos: exemplos, loading: false });
    }

    async function limparFiltros() {
        // Busca os dados do banco sem filtros
        let [exemplos, count] = await buscarExemplos({});
        // Atualiza o estado com os dados buscados e reseta os valores dos campos de filtro
        setState({ ...state, filtros: defaultState.filtros, filtroAtivo: false, exemplos: exemplos, count: count, loading: false });
    }

    function handleChangeFiltros(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        // se for dropdown, pega o valor selecionado
        if (target.type === 'select-one') {
            value = target.options[target.selectedIndex].value;
        }

        setState({
            ...state,
            filtros: {
                ...state.filtros,
                [name]: value
            }
        });
    }

    async function excluirExemplo() {
        let exemplo = state.registroAExcluir;
        if (exemplo.id_exemplo === "") return // if we don't have a title, we don't want to add a new todo
        try {
            let response = await del(`/exemplo/${exemplo.id_exemplo}`)
            if (response.ok) {
                let [exemplos, count] = await buscarExemplos({});
                setState({ ...state, exemplos: exemplos, count: count, mostrarModal: false, registroAExcluir: {}, loading: false });
                console.log(state);
            } else if (response.error) {
                console.log(response);
                console.error('Erro no excluirExemplo()', response.error);
            }
        } catch (error) {
            console.error('Erro no excluirExemplo():', error);
        }
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Gerenciamento de Exemplos</h2>
                    <p className="admin-subtitle">Área de testes e demonstração de componentes</p>
                </div>
                <Link to="/admin/exemplos/criar" className="btn-add-new">
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Exemplo
                </Link>
            </div>

            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    <Form>
                        <div className="row g-3">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Nome</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    placeholder="Nome do exemplo..." 
                                    name="nome" 
                                    value={state.filtros.nome} 
                                    onChange={handleChangeFiltros} 
                                />
                            </Form.Group>
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Descrição</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    placeholder="Descrição detalhada..." 
                                    name="descricao" 
                                    value={state.filtros.descricao} 
                                    onChange={handleChangeFiltros} 
                                />
                            </Form.Group>
                        </div>

                        <div className="filter-actions-row">
                            <div className="d-flex gap-2">
                                <Button className="btn-apply-filters" onClick={filtrarExemplos}>
                                    <FontAwesomeIcon icon={faFilter} className="me-2" /> Filtrar
                                </Button>
                                <Button className="btn-clear-filters" onClick={limparFiltros} title="Limpar">
                                    <FontAwesomeIcon icon={faSync} />
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '80px' }}>#</th>
                                <th>Nome</th>
                                <th>Descrição</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr><td colSpan="4" className="text-center py-5"><div className="spinner-border text-teal"></div></td></tr>
                            ) : state.exemplos.length > 0 ? (
                                state.exemplos.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-muted small">#{item.id_exemplo}</td>
                                        <td className="fw-bold">{item.nome}</td>
                                        <td className="text-muted small">{item.descricao}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" to={`/admin/exemplos/${item.id_exemplo}`} state={{ acao: "" }}><FontAwesomeIcon icon={faEye} /></Link>
                                                <Link className="action-icon edit" to={`/admin/exemplos/${item.id_exemplo}`} state={{ acao: "Editar" }}><FontAwesomeIcon icon={faPen} /></Link>
                                                <button className="action-icon delete" onClick={() => setState({ ...state, mostrarModal: true, registroAExcluir: item })}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="4" className="text-center py-4">Nenhum exemplo encontrado.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                    <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                </div>
            </Card>

            <Modal show={state.mostrarModal} onHide={() => setState({ ...state, mostrarModal: false })} centered className="modern-modal">
                <Modal.Header closeButton className="modal-header-teal">
                    <Modal.Title className="text-white fs-5">Excluir Exemplo</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p className="mb-0">Deseja realmente excluir o exemplo <strong>{state.registroAExcluir.nome}</strong>?</p>
                </Modal.Body>
                <Modal.Footer className="border-0 p-4 pt-0">
                    <Button variant="light" className="btn-modal-cancel" onClick={() => setState({ ...state, mostrarModal: false })}>Cancelar</Button>
                    <Button variant="danger" className="px-4" onClick={excluirExemplo}>Confirmar Exclusão</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default GerenciarExemplos;
